// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-grey[data-v-a9823e2c]{border-bottom:2px solid #e0e0e0}.novelty-caption[data-v-a9823e2c]{font-size:1.2em;background-color:#000;color:#fff}", ""]);
// Exports
module.exports = exports;
